import avatar from "../assets/images/avatar.png";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../firebase";

const Profile = () => {
  const [user] = useAuthState(auth);

  const signOut = () => {
    auth.signOut();
  };
  return (
    <div className="bg-gray-900 h-screen w-full sm:flex sm:justify-center">
      <div className="lg:w-[40%] lg:h-[50%] p-3">
        <div className="flex justify-center">
          {user.photoURL ? (
            <img src={user.photoURL} alt="" className="h-32 rounded-full" />
          ) : (
            <img src={avatar} alt="" className=" h-32 rounded-full" />
          )}
        </div>
        <div className="w-full mt-5">
          <div>
            <div className="bg-gray-700 flex justify-between items-center px-3">
              <h1 className="text-gray-100 py-2 px-1">{user.displayName}</h1>
              <h1 className="text-gray-100 py-2 px-1">{user.email}</h1>
            </div>

            <div className=" bg-gray-900">
              <h1 className="text-white text-lg font-bold py-3 px-2">Plans</h1>
            </div>

            <div className="">
              <div className="flex items-center justify-between px-3 bg-gray-800 mb-2">
                <div className="flex flex-col p-3 text-gray-200 font-bold text-base">
                  <p>Premium</p>
                  <p>4k + HDR</p>
                </div>
                <div>
                  <button className="bg-red-600 px-4 py-1 text-white shadow-2xl hover:bg-red-500 rounded-md">
                    Subscribe
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between px-3 bg-gray-800 mb-2">
                <div className="flex flex-col p-3 text-gray-200 font-bold text-base">
                  <p>Basic</p>
                  <p>780px</p>
                </div>
                <div>
                  <button className="bg-red-600 px-4 py-1 text-white shadow-2xl hover:bg-red-500 rounded-md">
                    Subscribe
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between px-3 bg-gray-800 mb-2">
                <div className="flex flex-col p-3 text-gray-200 font-bold text-base">
                  <p>Standerd</p>
                  <p>Mobile + Tablet</p>
                </div>
                <div>
                  <button className="bg-red-600 px-4 py-1 text-white shadow-2xl hover:bg-red-500 rounded-md">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>

            <div>
              <button
                onClick={signOut}
                className="bg-red-600 hover:bg-red-700 w-full py-2 text-white font-bold text-lg focus:outline-none"
              >
                Signout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
